import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  async createGroup(_, group) {
    const response = await axios.post('/blade/groups', group);
    return response.data.group;
  },
  async getGroups() {
    const response = await axios.get('/blade/groups');
    console.log(response);
    console.log(response.data.groups[0].players[0].roles);
    return response.data.groups;
  },
  async getGroup(_, { groupId }) {
    const { data } = await axios.get(`/blade/groups/${groupId}`);
    return data;
  },
  async getGroupTypes({ dispatch }) {
    return dispatch('getGroup', { groupId: 'types' });
  },
  async updateGroup(_, group) {
    const response = await axios.patch(`/blade/groups/${group._id}`, group);
    return response.data.group;
  },
  async deleteGroup(_, { groupId, _id }) {
    const did = groupId || _id;
    const { data: { group } } =
      await axios.delete(`/blade/groups/${did}`);
    return group;
  },
  async resetGroup(_, { groupId }) {
    const { data: { group } } =
      await axios.patch(`/blade/groups/${groupId}/reset`);
    return group;
  },
  // variant endpoints that permit profs but verify that you have access to the associated class
  async createClassGroup(_, group) {
    const response = await axios.post('/blade/classgroups', group);
    return response.data.group;
  },
  async getClassGroups(_, classId) {
    const { data: { groups } } = await axios.get(`/blade/classgroups/${classId}`);
    return groups;
  },
  async updateClassGroup(_, group) {
    const response = await axios.patch(`/blade/classgroups/${group._id}`, group);
    return response.data.group;
  },
  async deleteClassGroup(_, { groupId }) {
    const { data: { group } } =
      await axios.delete(`/blade/classgroups/${groupId}`);
    return group;
  },

  async getSaveStates(_, { groupId }) {
    console.log(`gid: ${groupId}`);
    const response = await axios.get(`/blade/savestates/${groupId}`);
    return response.data;
  },

  async createSaveState(_, { groupId, saveName }) {
    const response = await axios.post(`/blade/savestates/${groupId}/save`, { saveName });
    return response;
  },

  async restoreSaveState(_, { groupId, saveName }) {
    const response = await axios.post(`/blade/savestates/${groupId}/restore`, { saveName });
    return response;
  },

  async deleteSaveState(_, { groupId, saveName }) {
    const response = await axios.post(`/blade/savestates/${groupId}/delete`, { saveName });
    return response;
  },

  async copyGroupToClass(_, { groupId, classId }) {
    const response = await axios.post(`/blade/groups/${groupId}/copyToClass/${classId}`);
    return response.data;
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/groups.js